import { handleActions } from 'redux-actions'
import * as rawActions from '../actions'

const defaultState = false

export default handleActions(
  {
    [rawActions.reset](state, action) {
      return defaultState
    },
    [rawActions.openPoliciesViewer](state, action) {
      return true
    },
    [rawActions.closePoliciesViewer](state, action) {
      return false
    },
  },
  defaultState
)
